import { FaThumbsUp } from "react-icons/fa"
import Styles from '../styles/SuccessOrError.module.css'

export const Success = () => {
    return(
        <div className={Styles.success}>
            <p className={Styles.items}>Transaction Success</p>
            <FaThumbsUp  className={Styles.items}/>
        </div>
    )
}